module.exports = __webpack_public_path__ + "img/gnu_thumbnail.da5a2c52.jpg";